import * as React from 'react';
import styled from 'styled-components';

import { User } from 'apis/restaurant-api/merchant-admin/user/types';

import UserBadge from './UserBadge';

type Props = React.HTMLProps<HTMLDivElement> & {
  user?: User;
};

const getProfilePicUrl = (user?: User) => {
  let profilePicUrl;
  if (user && user.profile_photo) {
    profilePicUrl = user.profile_photo.url;
  } else if (user && user.profile_picture) {
    profilePicUrl = user.profile_picture.url;
  }
  return profilePicUrl;
};

const getEmail = (user?: User) => {
  return user && user.email;
};

const StyledUserBadge = styled(UserBadge)`
  cursor: pointer;
`;

const HeaderUserBadge = (props: Props) => {
  const profilePicUrl = getProfilePicUrl(props.user);
  const email = getEmail(props.user);

  return <StyledUserBadge onClick={props.onClick} profilePicUrl={profilePicUrl} email={email} />;
};

export default HeaderUserBadge;
